<div class="poi-info-tab">
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="details1Elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  @if (addressesByAddressSearch().length) {
    <app-address-search-result-box
      [addresses]="addressesByAddressSearch()"
      (addressSelected)="onAddressByAddressSearchSelected($event)"
      (searchClosed)="onSearchClosed()"></app-address-search-result-box>
  }
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="details2Elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  @if (addressesByGPSSearch().length) {
    <app-address-search-result-box
      [addresses]="addressesByGPSSearch()"
      (addressSelected)="onAddressByGPSSearchSelected($event)"
      (searchClosed)="onSearchClosed()"></app-address-search-result-box>
  }
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="variables.acceptanceRadiusElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <dv-button
    (click)="openEditMap()"
    [icon]="'map_marker_radius'"
    class="open-map-button"
    [disabled]="(canEditPOI$ | async) === false">
    {{ 'POI.ShowEditMap' | translate | uppercase }}
  </dv-button>
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="variables.activeElement | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <hr class="form-divider" />
  <dv-dynamic-form
    class="dynamic-form-background"
    [elements]="purposeElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  @if (variables.routeNetworkElements.length) {
    <hr class="form-divider" [style.margin-bottom]="'var(--dv-spacing-100)'" />
    <dv-dynamic-form
      [formTitle]="'POI.RouteNetwork' | translate | uppercase"
      [elements]="variables.routeNetworkElements | translateElements"
      [formGroup]="formGroup">
    </dv-dynamic-form>
  }
</div>

<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  (save)="onSave()">
</dv-save-panel>

<ng-template #poiMapAddressForm>
  <app-map-address-search-form
    [titleKey]="'POI.EditPoiOnMap'"
    [address]="currentLookupAddress()"
    (confirmBtnClicked)="onMapConfirmBtnClicked($event)"
    (coordinatesChanged)="onMapCoordinatesChanged($event)"
    (addressOrPostalPlaceChanged)="
      onAddressOrPostalPlaceChanges($event)
    "></app-map-address-search-form>
  @if (addressesByAddressSearch().length) {
    <app-address-search-result-box
      [addresses]="addressesByAddressSearch()"
      (addressSelected)="onAddressByAddressSearchSelected($event)"
      (searchClosed)="onSearchClosed()"></app-address-search-result-box>
  }
  @if (addressesByGPSSearch().length) {
    <app-address-search-result-box
      [addresses]="addressesByGPSSearch()"
      (addressSelected)="onAddressByGPSSearchSelected($event)"
      (searchClosed)="onSearchClosed()"></app-address-search-result-box>
  }
</ng-template>
